module.exports = __webpack_public_path__ + "a9642cf69d176b7e5ea8b87050749c6f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/salvador-dali.jpg
 ** module id = 392
 ** module chunks = 0
 **/